import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { documentsApi, type Document, type OCRResult } from '../../api/documents';

export function OCRReviewPage() {
  const [documents, setDocuments] = useState<Document[]>([]);
  const [results, setResults] = useState<Record<string, OCRResult>>({});
  const [error, setError] = useState('');

  useEffect(() => {
    void documentsApi.listDocuments(50).then((r) => setDocuments(r.documents)).catch((e) => setError(String(e)));
  }, []);

  const runOCR = async (doc: Document) => {
    try {
      const result = await documentsApi.runOCR(doc.id);
      setResults((prev) => ({ ...prev, [doc.id]: result }));
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div className="mx-auto max-w-4xl p-6">
      <Link to="/documents" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Document Center</Link>
      <h1 className="mt-2 text-2xl font-semibold">OCR Review</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <ul className="mt-6 space-y-4">
        {documents.map((d) => (
          <li key={d.id} className="rounded-lg border p-4 dark:border-slate-700">
            <div className="flex justify-between">
              <span className="font-medium">{d.name}</span>
              <button onClick={() => void runOCR(d)} className="text-sm text-blue-600 hover:underline">Run OCR</button>
            </div>
            {results[d.id] && (
              <div className="mt-3 text-sm">
                <p>Confidence: {(results[d.id].confidence * 100).toFixed(1)}%</p>
                <p className="mt-1 text-slate-600 dark:text-slate-400">{results[d.id].text}</p>
                {results[d.id].fields && (
                  <pre className="mt-2 overflow-x-auto rounded bg-slate-50 p-2 text-xs dark:bg-slate-800">
                    {JSON.stringify(results[d.id].fields, null, 2)}
                  </pre>
                )}
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
